import React from 'react';
import { PaymentMethod } from '@stripe/stripe-js';

import { Clickable, Icon, Layout, Text } from 'ds';

import { ReactComponent as StripeBank } from 'ds/StripeBank.svg';

interface SelectPaymentMethodCardProps {
  paymentMethod: PaymentMethod;
  selected: boolean;
  onSelect: (paymentMethod: PaymentMethod) => void;
}

const SelectPaymentMethodCard: React.FC<SelectPaymentMethodCardProps> = ({ paymentMethod, selected, onSelect }) => {
  return (
    <Clickable onClick={() => onSelect(paymentMethod)}>
      <Layout
        width="100%"
        height={68}
        padding={16}
        borderRadius={8}
        borderColor={selected ? 'blue-500' : 'gray-50'}
        borderWidth={selected ? 2 : 1}
      >
        <Layout direction="row" gap={12} align="center">
          {paymentMethod.us_bank_account && <StripeBank />}
          {paymentMethod.card && (
            <Layout width={32} height={32} borderRadius={8} color="gray-50" align="center" justify="center">
              <Icon name="creditCard" size="md" color="gray-500" />
            </Layout>
          )}
          <Layout direction="row" gap={4} align="center">
            <Text size="body-sm">
              {paymentMethod.card?.brand
                ? paymentMethod.card.brand.charAt(0).toUpperCase() + paymentMethod.card.brand.slice(1)
                : paymentMethod.us_bank_account?.bank_name}
            </Text>
            <Text size="body-sm">
              {paymentMethod.us_bank_account
                ? `•••• ${paymentMethod.us_bank_account?.last4}`
                : `•••• ${paymentMethod.card?.last4}`}
            </Text>
            {paymentMethod.card && (
              <Layout marginLeft={12}>
                <Text size="body-sm">
                  {paymentMethod.card?.exp_month}/{paymentMethod.card?.exp_year}
                </Text>
              </Layout>
            )}
          </Layout>
        </Layout>
      </Layout>
    </Clickable>
  );
};

export default SelectPaymentMethodCard;
